import { render, staticRenderFns } from "./KioskNew.vue?vue&type=template&id=8008f554"
import script from "./KioskNew.vue?vue&type=script&lang=js"
export * from "./KioskNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports